/**
 * @file recruitment.types.ts
 * @path apps/website/src/features/recruitment/recruitment.types.ts
 */
import { z } from "zod";

export const jobApplicationSchema = z.object({
  fullName: z
    .string()
    .trim()
    .min(2, "Name must be at least 2 characters")
    .max(100, "Name must be less than 100 characters"),
  email: z
    .string()
    .trim()
    .email("Invalid email address")
    .max(255, "Email must be less than 255 characters"),
  phone: z
    .string()
    .trim()
    .min(10, "Phone number must be at least 10 digits")
    .max(20, "Phone number must be less than 20 characters"),
});

export type JobApplicationFormData = z.infer<typeof jobApplicationSchema>;

export type RecruitmentStep = {
  id: string;
  title: string;
  description: string;
  media: {
    type: "image" | "video";
    src: string;
  };
};

export interface SubmitApplicationPayload extends JobApplicationFormData {
  jobId: string;
  jobTitle: string;
  jobLocation: string;
  cvFileBase64: string;
  cvFileName: string;
}
